import { useState } from 'react'
import ResumeForm from '../components/ResumeForm'
import ResumePreviewLayout from '../components/ResumePreviewLayout';
import { useLocation } from 'react-router-dom';

const ResumeBuilder = () => {
  const [formData, setFormData] = useState({});
  const getFormData = (data) => {
    setFormData(data)
    localStorage.setItem("formData", JSON.stringify(data))
  }

  const history = useLocation();
  const templateId = history?.state?.id;

  return (
    <div className='flex'>
      <ResumeForm getFormData={getFormData}  templateId={templateId}/>
        <div className='hidden md:block '>
          <ResumePreviewLayout formData={formData}/>

        </div>
       


    </div>

  )
}

export default ResumeBuilder